import DatePickerComponent from "./karendaa-day-picker";

export default DatePickerComponent;
